import Navbar from "../Navbar"

export default function Header() {


    return (
        <header className="project--header transition-colors duration-300 bg-secondary dark:bg-gray-900 overflow-visible">
            <Navbar />
        </header>
    )
}